var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "17", height: "16", viewBox: "0 0 17 16" }, props),
    React.createElement("path", { d: "M9.5 2c.552 0 1 .448 1 1v1h3c.276 0 .5.224.5.5 0 .245-.177.45-.41.492L13.5 5H13v7c0 1.105-.895 2-2 2H5c-1.105 0-2-.895-2-2V5h-.5c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h3V3c0-.552.448-1 1-1h3zM12 5H4v7c0 .552.448 1 1 1h6c.552 0 1-.448 1-1V5zM6.5 7c.276 0 .5.224.5.5v3c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-3c0-.276.224-.5.5-.5zm3 0c.276 0 .5.224.5.5v3c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-3c0-.276.224-.5.5-.5zm0-4h-3v1h3V3z", transform: "translate(.043)", fill: "#303030", fillRule: "evenodd" })
  );
});